let answerheight;
let plusminus;

$('.question-item').click(function() {
    $('.question-item').not(this).removeClass('active-question');
    $(this).toggleClass('active-question');
}); 

function setfaqheights() {
$( ".question-answer" ).each(function() {
    answerheight = $(this).find('.question-answer-inner').height();
    $(this).css('max-height',`${answerheight}px`);
    $(this).attr('data-height',`${answerheight}`);
});
}

$( document ).ready(function() {
    setfaqheights();
 });


 window.addEventListener('resize', function () {
    setfaqheights();
 });
